var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65 22.5L6.75 19.25L2.975 18.475L3.4 14.8L1 12L3.4 9.225L2.975 5.55L6.75 4.775L8.65 1.5L12 3.05L15.35 1.5L17.275 4.775L21.025 5.55L20.6 9.225L23 12L20.6 14.8L21.025 18.475L17.275 19.25L15.35 22.5L12 20.95L8.65 22.5ZM10.925 15.325L16.6 9.7L15.475 8.675L10.925 13.175L8.55 10.7L7.4 11.825L10.925 15.325Z",
    fill: "url(#paint0_linear_2492_7167)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65 22.5L6.75 19.25L2.975 18.475L3.4 14.8L1 12L3.4 9.225L2.975 5.55L6.75 4.775L8.65 1.5L12 3.05L15.35 1.5L17.275 4.775L21.025 5.55L20.6 9.225L23 12L20.6 14.8L21.025 18.475L17.275 19.25L15.35 22.5L12 20.95L8.65 22.5ZM10.925 15.325L16.6 9.7L15.475 8.675L10.925 13.175L8.55 10.7L7.4 11.825L10.925 15.325Z",
    fill: "black",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2492_7167",
    x1: 5,
    y1: 1,
    x2: 20.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F80ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176ADA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.8c0c33f31c281bdb8704059fc9a2af20.svg";
export { ForwardRef as ReactComponent };